import { render, staticRenderFns } from "./addlocdev.vue?vue&type=template&id=650c0840&scoped=true"
import script from "./addlocdev.vue?vue&type=script&lang=js"
export * from "./addlocdev.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650c0840",
  null
  
)

export default component.exports